import React from 'react';
import { FsProps, FieldSelectDB } from 'motion-components';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import i18next from 'i18next';
type Props = FsProps;

const gqlGet = gql`
  query getRouteStates($where: String, $offset: Int, $limit: Int, $order: String) {
    getRouteStates(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
      }
      recordCount
    }
  }
`;
export const FieldSelectRouteState = ({
  label = i18next.t('Κατάσταση Δρομολογίου'),
  name = 'statusId',
  defaultValues = {},
  ...rest
}: Props) => {
  function useGetLazyQuery() {
    return useLazyQuery(gqlGet, { fetchPolicy: 'no-cache' });
    //return [null, { loading: null, data: null }];
  }
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={JSON.stringify({})}
      hook={useGetLazyQuery}
    />
  );
};
